import { ReactNode, useState } from "react";
import { FCX } from "@datassential/platform-ui-lib";
import cn from "classnames";
import { IFoodProfileSummary } from "@models/NewFoodProfileSummary";
import ProfileSidebarToggle from "@components/ProfileSidebarToggle/ProfileSidebarToggle";
import FoodProfileSidebar from "@pages/Food/refresh/components/FoodProfileSidebar/FoodProfileSidebar";
import "./FoodProfileSidebarLayout.scss";

interface Props {
    summary: IFoodProfileSummary;
    children: ReactNode;
}

/**
 * Puts the Food Profile content next to the sticky, collapsible sidebar.
 * The `--collapsed` modifier lets content sections widen their layout in CSS when the sidebar is collapsed.
 */
const FoodProfileSidebarLayout: FCX<Props> = ({ summary, children }) => {
    const [isCollapsed, setIsCollapsed] = useState(false);

    return (
        <div className={cn("FoodProfileSidebarLayout", isCollapsed && "FoodProfileSidebarLayout--collapsed")}>
            <FoodProfileSidebar summary={summary} isCollapsed={isCollapsed}/>
            <ProfileSidebarToggle
                testId="blockFoodSidebarDivider"
                buttonTestId="buttonFoodSidebarCollapse"
                isCollapsed={isCollapsed}
                onToggle={() => setIsCollapsed(prev => !prev)}
            />
            <div className="FoodProfileSidebarLayout__main">{children}</div>
        </div>
    );
};

export default FoodProfileSidebarLayout;
